import colors from './colors';

const palette = {
  primary: {
    main: colors.pureWhite,
  },
  text: {
    primary: colors.pureWhite,
  },
  background: {
    default: colors.black2,
  },
  divider: colors.black1,
};

export default palette;
